import { FaRotateRight } from "react-icons/fa6";

const RotateRightIcon = ({ size, className, title, onClick, disabled }) => {
  return (
    <FaRotateRight
      className={className}
      size={size}
      title={title}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

RotateRightIcon.defaultProps = {
  className: "",
  title: "Rotate Right",
  onClick: () => {},
  disabled: false,
};

export default RotateRightIcon;
